// extracted by mini-css-extract-plugin
export default {"TitleAndSubtitle_container":"TitleAndSubtitle_TitleAndSubtitle_container__xEtuN","hiragana_p":"TitleAndSubtitle_hiragana_p__ialJ5"};